export const VerifyPasswordState = {
  NONE: 'none',
  VALID: 'valid',
  INVALID: 'invalid',
};

export const PasswordValidationCodes = {
  MIN_LENGTH: 'min_length',
  NUMBER_UPPER_LOWER: 'number_upper_lower',
  SPECIAL_CHARACTER: 'special_caracter',
  BE_DIFFERENT_TO_CURRENT: 'be_different_to_current',
  EXACT_MATCH: 'exact_match',
} as const;

const SPECIAL_CHARACTERS: string[] = [
  '\\^',
  ' ',
  '$',
  '*',
  '\\.',
  '[',
  '\\]',
  '{',
  '}',
  '(',
  ')',
  '?',
  '"',
  '!',
  '@',
  '#',
  '%',
  '&',
  '/',
  '\\\\',
  ',',
  '>',
  '<',
  "'",
  ':',
  ';',
  '|',
  '_',
  '~',
  '`',
  '+',
  '=',
  '-',
];

const specialCharactersRegExp = new RegExp(`[${SPECIAL_CHARACTERS.join('')}]`);

export const PasswordValidationRegExp = {
  SPECIAL_CHARACTER: specialCharactersRegExp,
  NUMBER_UPPER_LOWER: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/,
} as const;

export const PasswordValidation = {
  MIN_LENGTH: 8,
} as const;
